export enum DataGridTypes {
  AUTO = 'auto',
  FIXED = 'fixed',
}
